import React from 'react';
import { Detail } from '../types';
import YearValuesTable from '../components/details/YearValuesTable';

type DetailRenderer = (detail: Detail) => React.ReactNode;

const JSON_TABLE_CODES = new Set([
    'indicator_values_json',
    'activity_values_json',
    'year_values_json',
]);

const registry: Record<string, DetailRenderer> = {};

for (const code of JSON_TABLE_CODES) {
    registry[code] = (detail) => <YearValuesTable value={detail.value} />;
}

export function renderDetail(detail: Detail): React.ReactNode {
    const renderer = registry[detail.code];
    if (renderer) return renderer(detail);
    return typeof detail.value === 'object'
        ? JSON.stringify(detail.value)
        : String(detail.value ?? '');
}

export function hasCustomRenderer(code: string): boolean {
    return code in registry;
}
